import { render } from "./footer.vue?vue&type=template&id=b0f2fcb4&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=b0f2fcb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0f2fcb4"

export default script